import { render } from "./FaqView.vue?vue&type=template&id=d9016894"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__